/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Mailing,
    MailingFromJSON,
    MailingFromJSONTyped,
    MailingToJSON,
} from './';

/**
 * 
 * @export
 * @interface MailingDataFrame
 */
export interface MailingDataFrame {
    /**
     * 
     * @type {number}
     * @memberof MailingDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof MailingDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof MailingDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<Mailing>}
     * @memberof MailingDataFrame
     */
    data: Array<Mailing>;
}

export function MailingDataFrameFromJSON(json: any): MailingDataFrame {
    return MailingDataFrameFromJSONTyped(json, false);
}

export function MailingDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailingDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(MailingFromJSON)),
    };
}

export function MailingDataFrameToJSON(value?: MailingDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(MailingToJSON)),
    };
}


